import React from "react";
import { Box, Container, Typography, Divider, Stack, Avatar } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";

const stack = [
  { name: "React", version: "18.3", color: "#61dafb" },
  { name: "MUI", version: "7.x", color: "#007fff" },
  { name: "React Router", version: "7.x", color: "#ca4245" },
  { name: "Vercel", version: "Deploy", color: "#000000" },
];

export default function About() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Avatar sx={{ bgcolor: "primary.main", width: 64, height: 64, mx: "auto", mb: 2 }}>
          <CodeIcon fontSize="large" />
        </Avatar>
        <Typography variant="h3" fontWeight={800} mb={2}>
          Acerca del proyecto
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={520} mx="auto">
          Este proyecto es una plantilla base lista para producción que combina las últimas
          versiones de React y Material UI, con routing y deploy en Vercel preconfigurado.
        </Typography>
      </Box>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" fontWeight={700} mb={3}>
        Stack tecnológico
      </Typography>
      <Stack spacing={2}>
        {stack.map((tech) => (
          <Box
            key={tech.name}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              backgroundColor: "background.paper",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: tech.color }} />
              <Typography fontWeight={600}>{tech.name}</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              v{tech.version}
            </Typography>
          </Box>
        ))}
      </Stack>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" fontWeight={700} mb={2}>
        Estructura del proyecto
      </Typography>
      <Box
        component="pre"
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: "#0d1117",
          color: "#e6edf3",
          fontFamily: "monospace",
          fontSize: "0.875rem",
          overflow: "auto",
        }}
      >
        {`src/
├── components/
│   ├── Navbar.jsx
│   └── Footer.jsx
├── pages/
│   ├── Home.jsx
│   ├── About.jsx
│   └── Contact.jsx
├── theme/
│   └── index.js
├── App.jsx
└── index.js`}
      </Box>
    </Container>
  );
}
